import { Box, styled } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
    marginBottom: '1rem',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    borderRadius: '0.5rem',
    border: '1px solid #EBEEFE'
}));
